module.exports = __webpack_public_path__ + "img/PostNord.a5adc8b6.png";